/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import keyBy from 'lodash/fp/keyBy.js';
import { MODE_SHAPE_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';

const methods = [
  { id: MODE_SHAPE_METHOD_VALUES.SP3, name: 'SP3 Default' },
  { id: MODE_SHAPE_METHOD_VALUES.UPLOAD, name: 'User Defined Upload' },
];

export const methodById = keyBy('id', methods);

export default methods;
